// extracted by mini-css-extract-plugin
export default {"imageWrapper":"OI-z","twoColumnImage":"PI-z"};